class StSelectFilterController {
  constructor($translate) {
    'ngInject';
    this.$translate = $translate;
    this.name = 'stSelect';
    this.dropText = this.$translate.instant(this.items[0].name);
  }
  toggleFilter(item) {
    this.dropText = this.$translate.instant(item.name);
    this.filter = item.filter;
  }
}

export default StSelectFilterController;



// WEBPACK FOOTER //
// ./client/app/common/stSelectFilter/stSelectFilter.controller.js